import { makeStyles } from "@material-ui/core/styles";

export const installationPageStyles = makeStyles((theme) => ({
  accordion: {
    marginBottom: theme.shape.padding,
    border: `1px solid lightgray`,
    borderRadius: "5px !important",
  },
  agentSetupStepsContainer: {
    display: "flex",
    flexDirection: "column",
  },
  title: {
    fontSize: 22,
    fontWeight: "bold",
  },
  agentSetupStepContainer: {
    display: "flex",
    marginBottom: theme.shape.padding,
  },
  circularNumberContainer: {
    width: 30,
    height: 30,
    borderRadius: 15,
    textAlign: "center",
    marginRight: theme.shape.padding,
    border: `2px solid ${theme.palette.text.primary}`,
    "& p": {
      margin: 0,
      fontWeight: "bold",
    },
  },
  stepTextOuterContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  stepTextInnerContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    "& p": {
      marginBottom: 0,
    },
    "& a": {
      paddingLeft: 5,
      color: theme.palette.primary.main,
    },
  },
  installationKeySelect: {
    width: 250,
  },
  textField: {
    marginTop: theme.shape.padding,
  },
  copyButton: {
    width: 100,
    color: theme.palette.primary.main,
    margin: `${theme.shape.padding}px 0`,
    backgroundColor: theme.palette.background.paper,
  },
  titleContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    padding: `20px ${theme.shape.padding}px 60px`,
  },
  dialogAlert: {
    marginBottom: theme.shape.padding,
  },
  dialogActions: {
    borderTop: `1px solid ${theme.palette.divider}`,
    padding: 20,
    display: "flex",
    justifyContent: "space-between",
  },
  inputIcons: {
    cursor: "pointer",
    color: theme.palette.text.primary,
    "& svg": {
      color: theme.palette.text.primary,
    },
    "&.Mui-disabled": {
      "& svg": {
        color: theme.palette.action.disabled,
      },
    },
  },
  errorTextButton: {
    color: theme.palette.error.main,
  },
  errorContainedButton: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.error.main,
  },
  tooltip: {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
  },
  readOnlyField: {
    "& .MuiInput-root": {
      border: 0,
      marginBottom: 20,
    },
  },
}));
